import React, { FC } from 'react';
import { styled } from '@mui/material';
import { ONE_HUNDRED_VALUE } from 'common/config/app';
import { InfoCard } from 'components';
import { getNumberValue } from 'utilities';
import { DialogHeaderProps } from './types';

const PREFIX = 'DialogHeader';

const classes = {
  infoCards: `${PREFIX}-infoCards`,
};

const Root = styled('div')(() => ({
  [`&.${classes.infoCards}`]: {
    display: 'flex',
    padding: '1rem 2.5rem',
    backgroundColor: '#f1f4f6',

    '& .MuiPaper-root': {
      flexGrow: 1,
      '&:last-child': {
        marginRight: 0,
      },
    },
  },
}));

const DialogHeader: FC<DialogHeaderProps> = props => {
  const { effectiveTaxRateInfo } = props;

  const efectiveTaxRateInfoValue = getNumberValue(Number(effectiveTaxRateInfo));

  return (
    <Root className={classes.infoCards}>
      <InfoCard title="TAX RATE LEDGER" body={`${(efectiveTaxRateInfoValue * ONE_HUNDRED_VALUE).toFixed(1)} %`} />
    </Root>
  );
};

export default DialogHeader;
